<section>
    <header class="col-12 header-page">
        <h1 class="header__page__content__title">Simulação do Plano IV</h1>
        <p>
            O Beneficiário terá a possibilidade de realizar uma simulação do seu benefício com a idade mínima para se
            aposentar segundo as regras da Fundação Copel. Lembrando que, para o beneficiário ter direito a
            aposentadoria é necessário ter idade igual ou superior a 45 anos, 5 anos de contribuição ao Plano, tenha se
            desligado da patrocinadora e o valor do benefício mínimo igual ou superior a R$ 1.500,00
        </p>
    </header>
    <main class="main__content col-xl-12">
        <form class="col-xl-12 col-lg-12 col-md-12 col-sm-12 main__page__content__form" [formGroup]="formGroup"
            (ngSubmit)="consultar()">
            <section class="col-12 content-form">
                <div class="col-xl-4 col-md-4 col-sm-12 px-1 mt-2">
                    <label class="content__form__title__label__duvida">
                        Percentual Sobre o Salario (SRC)
                        <duvida [textoAviso]="'Percentual a ser utilizado do salario para aposentadoria.'">
                        </duvida>
                    </label>
                    <ng-select placeholder="Selecione" formControlName="percentualSobreSRC" [items]="this.percentual">
                        <ng-template>
                            {{percentual}}%
                        </ng-template>
                    </ng-select>
                </div>
                <div class="col-xl-4 col-md-4 col-sm-12 px-1 mt-2">
                    <label class="content__form__title__label__duvida">
                        Estimativa de Rentabilidade
                        <duvida
                            [textoAviso]="'Corresponde ao retorno dos investimentos que incide na reserva de poupança do participante. É possível simular em 4%, 5% ou 6%.'">
                        </duvida>
                    </label>
                    <ng-select placeholder="Selecione" formControlName="taxaJuros" [items]="this.taxa">
                        <ng-template>
                            {{taxa}}%
                        </ng-template>
                    </ng-select>
                </div>
                <div class="col-xl-4 col-md-4 col-sm-12 px-1 mt-2">
                    <label class="content__form__title__label__duvida">
                        Aporte
                        <duvida
                            [textoAviso]="'Contribuição esporádica, de qualquer valor, realizada pelo participante através de boleto.'">
                        </duvida>
                    </label>
                    <input class="form-control" prefix="R$ " maxlength="14"
                        [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }" currencyMask
                        formControlName="aporte" placeholder="R$ 0,00" />
                </div>
                <div class="col-xl-4 col-md-4 col-sm-12 px-1 mt-2">
                    <label class="content__form__title__label__duvida">
                        Idade Prevista
                        <duvida
                            [textoAviso]="'Idade para qual deseja se aposentar. O simulador já indica como inicial a idade em que o participante cumpre todas as carências para receber o benefício.'">
                        </duvida>
                    </label>
                    <input class="form-control" min="{{valorMinimoIdade}}" [max]="valorMaximoIdade" type="number"
                        formControlName="anoAposentar" />
                </div>
                <div class="col-xl-4 col-md-4 col-sm-12 px-1 mt-2">
                    <label class="content__form__title__label__duvida">
                        Meses Previsto
                        <duvida [textoAviso]="'Complemento de meses para a idade em que deseja se aposentar.'"></duvida>
                    </label>
                    <ng-select [items]="this.meses" bindLabel="asc" bindValue="asc" placeholder="Selecione"
                        formControlName="mesAposentar" appendTo="body">
                    </ng-select>
                </div>
                <div class="col-xl-4 col-md-4 col-sm-12 px-1 mt-2">
                    <label class="content__form__title__label__duvida">Tipo de Recebimento</label>
                    <ng-select [items]="this.tipoRecebimento" bindLabel="asc" bindValue="asc" placeholder="Selecione"
                        formControlName="tipoRecebimento" appendTo="body">
                    </ng-select>
                </div>
                <div class="col-xl-4 col-md-4 col-sm-12 px-1 mt-2"
                    *ngIf="this.formGroup.value.tipoRecebimento == 'Percentual ao mês'">
                    <label class="content__form__title__label__duvida">Percentual ao mês</label>
                    <input class="form-control" formControlName="percentualRecebimento" />
                </div>
                <div class="col-xl-4 col-md-4 col-sm-12 px-1 mt-2"
                    *ngIf="this.formGroup.value.tipoRecebimento == 'Prazo determinado'">
                    <label class="content__form__title__label__duvida">Prazo determinado</label>
                    <input class="form-control" formControlName="prazoRecebimento" />
                </div>
            </section>
            <div class="col-12 p-0 content__form__buttons">
                <button class="btn button-primary col-xl-2 col-lg-3 col-md-4 col-sm-12 mr-xl-1 mr-lg-1" type="submit"
                    [disabled]="this.loading">
                    <div class="d-flex" *ngIf="loading; else showSpan">
                        <span class="spinner">
                        </span>
                        <span> Simulando</span>
                    </div>
                    <ng-template #showSpan>
                        <span>Simular</span>
                    </ng-template>
                </button>
            </div>
        </form>
        <ng-template #showLoading>
            <spinner [show]="loading"></spinner>
        </ng-template>
        <div class="content_download_pdf">
            <div>
                <h3 class="content_download_pdf_title">
                    Exportar
                </h3>
            </div>
            <section class="d-flex">
                <button [disabled]="this.loading">
                    <div class="d-flex" *ngIf="this.loadingPdf; else showLoadingPdf">
                        <span class="spinner-button-export">
                        </span>
                    </div>
                    <ng-template #showLoadingPdf>
                        <fa-icon [icon]="faPdf" (click)="printPdf()"></fa-icon>
                    </ng-template>
                </button>
                <button [disabled]="this.loading">
                    <div class="d-flex" *ngIf="loadingCsv; else showLoadingCsv">
                        <span class="spinner-button-export">
                        </span>
                    </div>
                    <ng-template #showLoadingCsv>
                        <fa-icon [icon]="faExcel" (click)="printCsv()"></fa-icon>
                    </ng-template>
                </button>
            </section>
        </div>
        <div *ngIf="simulation">
            <h2 class="main__page__content__title col-7 px-0">
                Minha Reserva
            </h2>
            <section class="col-xl-12 col-12 px-1 card-container">
                <section class="card" [@fadeIn]>
                    <span class="content__card__title">Valor Total de Contribuição</span>
                    <p class="content__card__content">{{ simulation.contribuicaoTotal | currency:'BRL'}}</p>
                </section>
                <section class="card" [@fadeIn]>
                    <span class="content__card__title">Total de Rendimentos das Contribuições</span>
                    <p class="content__card__content">{{(simulation.rentabilidade) | currency:'BRL'}}</p>
                </section>
                <section class="card" [@fadeIn]>
                    <span class="content__card__title">Valor Total de Reserva</span>
                    <p class="content__card__content">{{ simulation.saldoTotal | currency:'BRL'}}</p>
                </section>
            </section>
            <section class="col-xl-12 px-1">
                <header class="content__header">
                    <h3>Contribuições / Beneficio</h3>
                    <filtro-dados [pageItens]="10" [totalItens]="totalItems"
                        (changeQuantidade)="onChangeQuantidadeItens($event)">
                    </filtro-dados>
                </header>
                <main>
                    <section class="content__header__table">
                        <div class="col-xl-1">Sequencia</div>
                        <div class="col-xl-2">Data do Pagamento</div>
                        <div class="col-xl-2">Contribuição Participante</div>
                        <div class="col-xl-2">Contribuição Patrocinadora</div>
                        <div class="col-xl-2">Rentabilidade</div>
                        <div class="col-xl-1">Beneficio</div>
                        <div class="col-xl-2">Saldo Final</div>
                    </section>
                    <section class="content__main__table mt-1">
                        <section class="table__card col-12 row" *ngFor="let item of itemsPage; index as i">
                            <div class="col-xl-1"> <span> {{ item.sequencia }} </span> </div>
                            <div class="col-xl-2">
                                <span> {{ item.dataReferencia | date:'dd/MM/yyyy' }} </span>
                            </div>
                            <div class="col-xl-2">
                                <span> {{ item.contribuicaoParticipante / 2 | currency:'BRL':'symbol':'1.2-2':'pt' }}
                                </span>
                            </div>
                            <div class="col-xl-2">
                                <span> {{ item.contribuicaoParticipante / 2 | currency:'BRL':'symbol':'1.2-2':'pt' }}
                                </span>
                            </div>
                            <div class="col-xl-2">
                                <span> {{ item.rentabilidade | currency:'BRL':'symbol':'1.2-2':'pt' }} </span>
                            </div>
                            <div class="col-xl-1">
                                <span> {{ item.beneficio | currency:'BRL':'symbol':'1.2-2':'pt' }} </span>
                            </div>
                            <div class="col-xl-2">
                                <span> {{ item.saldoFinal | currency:'BRL':'symbol':'1.2-2':'pt'}} </span>
                            </div>
                        </section>
                    </section>
                </main>
                <footer>
                    <paginacao [currentPage]="1" [collectionSize]="totalItems" [pageSize]="items"
                        (changeNumber)="onChangePagination($event)">
                    </paginacao>
                </footer>
            </section>
        </div>
    </main>
    <footer class="footer__page__content">
        <article class="footer__page__atencao">
            <p class="footer__title">ATENÇÃO</p>
            <br>
            <p class="footer__content footer__content__atencao">
                A simulação considera, para o cálculo do benefício futuro, a última contribuição do participante como
                sendo padrão para os próximos meses até a data aposentadoria.
                Nos meses em que houver verbas como 13º, férias, por exemplo, a contribuição do participante será maior,
                resultando em uma projeção do benefício também maior.
                Cabe ressaltar que a simulação é uma projeção e não representa garantia ou compromisso de pagamento do
                valor simulado. Contudo, para um valor mais próximo da realidade,
                a simulação deve ser feita em meses que não incidirem as verbas extras.
            </p>
        </article>
        <article class="footer__page__informacoes">
            <p class="footer__page__informacoes__title__informacoes footer__title">INFORMAÇÕES</p>
            <br>
            <p class="ml-1 content-informacoes"
                *ngIf="!simulation || simulation.totalProventos >= simulation.socialSecurityUnit * 2">
                Caso os valores apresentados ainda não estejam dentro da sua expectativa, existem formas de melhorar o
                seu benefício, como contribuir por mais tempo, aumentar sua contribuição extra mensal ou realizar
                aportes.
            </p>
            <br>
            <p class="footer__page__informacoes__title__notas footer__title mt-1">NOTAS</p>
            <br>
            <div>
                <ul class="footer__content__notas">
                    <li>O resultado dessa simulação é uma projeção que não se constitui, de modo algum, em garantia,
                        proposta ou obrigação por parte da Fundação Copel.</li>
                    <li>O valor do saldo projetado foi estimado com base em uma hipótese de rentabilidade que você
                        simulou na fase de capitalização, porém, a rentabilidade real dependerá da performance das
                        aplicações.</li>
                    <li>Para a conversão em renda foi utilizada a hipótese de taxa de juros vigente.</li>
                    <li>O valor do aporte apresentado, quando for o caso, representa apenas uma das condições para a
                        elegibilidade para o benefício.
                        Deverão ser verificadas as demais condições de elegibilidade como idade e tempo de filiação.
                    </li>
                    <li>Os valores simulados podem ter variação de acordo com o motivo do desligamento. Havendo dúvidas
                        favor entrar em contato com nossa Central de Atendimento</li>
                </ul>
            </div>
        </article>
    </footer>
</section>